export const ContentType = {
  GUIDE: 'guide',
  ITINERARY: 'itinerary',
  USER_PROFILE: 'user_profile',
};


// ReportReason must match to enums on the frontend exactly!
export const ReportReason = {
  INAPPROPRIATE_CONTENT: 'Inappropriate Content',
  SPAM: 'Spam',
  HARASSMENT_OR_HATE_SPEECH: 'Harassment or Hate Speech',
  COPYRIGHT_VIOLATION: 'Copyright Violation',
  OTHER: 'Other',
};
